import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { X, ArrowLeft } from "lucide-react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export default function CheckoutCancelPage() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");

  return (
    <div className="bg-zinc-950 min-h-screen text-white">
      <Navbar />
      <main className="pt-28 pb-20 min-h-[60vh] flex items-center justify-center px-6">
        <div data-testid="checkout-cancel-page" className="max-w-xl w-full bg-zinc-900 border-4 border-zinc-700 p-10 text-center">
          <div className="inline-flex items-center justify-center bg-zinc-800 text-zinc-300 w-24 h-24 mb-6 border-4 border-zinc-700">
            <X className="w-14 h-14" strokeWidth={3} />
          </div>
          <h1 className="font-heading text-4xl uppercase text-white mb-3">Pagamento annullato</h1>
          <p className="text-zinc-400 mb-2">Hai annullato il pagamento. Il tuo ordine non è andato a buon fine.</p>
          {orderId && (
            <p className="text-zinc-500 text-sm">ID ordine: <span className="text-zinc-400 font-mono">#{orderId.slice(0, 8).toUpperCase()}</span></p>
          )}
          <p className="text-zinc-500 text-sm mt-4">Se è stato un errore puoi tornare al sito e riprovare.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
            <Link to="/" data-testid="cancel-go-home"
              className="bg-yellow-400 text-black font-heading uppercase px-6 py-3 hover:bg-white transition flex items-center gap-2 justify-center">
              <ArrowLeft className="w-4 h-4" /> Torna al sito
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
